<template>
    <div>
        <GridColumnMenuSort :column="column" :sortable="sortable" :sort="sort" @closemenu="closeMenu"
            @sortchange="sortChange" />
        <GridColumnMenuItemGroup>
            <!-- <GridColumnMenuItem :title="'Columns'" :icon-class="'k-i-columns'" @menuitemclick="onMenuItemClick" /> -->
            <GridColumnMenuCheckboxFilter 
               :column="column" 
                :filter="filter" 
                :filterable="filterable"
                :unique-data="uniqueData" 
                :search-box="false" 
                :data-items="filterItems"
                :expanded="true"
                @filterchange="filterChange" 
                @expandchange="expandChange" 
                @closemenu="closeMenu" 
                :show="true"  
            />
        </GridColumnMenuItemGroup>
    </div>
</template>

<script>
import {
    GridColumnMenuFilter,
    GridColumnMenuSort,
    GridColumnMenuItemGroup,
    GridColumnMenuItemContent,
    GridColumnMenuItem,
    GridColumnMenuCheckboxFilter 
} from '@progress/kendo-vue-grid';
import { Button } from '@progress/kendo-vue-buttons';

export default {
    props: {
        column: Object,
        sortable: [Boolean, Object],
        sort: {
            type: Array
        },
        filter: Object,
        filterable: Boolean,
        columns: Array,
        uniqueData: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            currentColumns: [],
            columnsExpanded: true,
            filterExpanded: true, 
            originalItems: [ 
                {value:"A+", eBoothGradeNameEn: 'Grade A+', eBoothGradeNameTc: 'A+級展台', eBoothGradeNameSc: 'A+级展台'},
                {value:"A",eBoothGradeNameEn: 'Grade A', eBoothGradeNameTc: 'A級展台', eBoothGradeNameSc: 'A级展台'},
                {value:"B",eBoothGradeNameEn: 'Grade B', eBoothGradeNameTc: 'B級展台', eBoothGradeNameSc: 'B级展台'},
                {value:"C",eBoothGradeNameEn: 'Grade C', eBoothGradeNameTc: 'C級展台', eBoothGradeNameSc: 'C级展台'},
                {value:"Basic",eBoothGradeNameEn: 'Basic', eBoothGradeNameTc: '基本展台', eBoothGradeNameSc: '基本展台'},
                {value:"Free",eBoothGradeNameEn: 'Free', eBoothGradeNameTc: '免費展台', eBoothGradeNameSc: '免费展台'},
                {value:"no_ebooth",eBoothGradeNameEn: 'No eBooth', eBoothGradeNameTc: '没有展台', eBoothGradeNameSc: '没有展台'},
            ], 
        };
    },
    created() {
        console.log('column:'+this.column)
        this.$data.currentColumns = this.$props.columns;
    },
    components: {
        'GridColumnMenuSort': GridColumnMenuSort,
        'GridColumnMenuFilter': GridColumnMenuFilter,
        'GridColumnMenuItemGroup': GridColumnMenuItemGroup,
        'GridColumnMenuItemContent': GridColumnMenuItemContent,
        'GridColumnMenuItem': GridColumnMenuItem,
        'kbutton': Button,
        'GridColumnMenuCheckboxFilter': GridColumnMenuCheckboxFilter
    },
    computed: {
        oneVisibleColumn() {
            return this.currentColumns.filter(c => !c.hidden).length === 1;
        },
        
        // 计算属性：将原始数据转换为过滤组件需要的数据格式
        filterItems() { 
            const currentLang = localStorage.getItem('currentLangId'); 
            const langMap = {
                '936': 'eBoothGradeNameSc',
                '950': 'eBoothGradeNameTc',
                '1252': 'eBoothGradeNameEn'
            };
            
            // 获取当前语言对应的字段名
            const currentField = langMap[currentLang] || 'eBoothGradeNameSc';
            
            // 转换数据格式
            return this.originalItems.map(item => ({  
                eBoothGrade: item[currentField] // 根据当前语言显示文本
            }));
        }
    },
    methods: {
        handleFocus(e) {
            console.log('contentfocus')
            this.$emit("contentfocus", e);
        },
        onToggleColumn(id) {
            this.currentColumns = this.currentColumns.map((column, idx) => {
                return idx === id ? { ...column, hidden: !column.hidden } : column;
            });
        },
        onReset(event) {
            event.preventDefault();
            const allColumns = this.$props.columns.map(col => {
                return {
                    ...col,
                    hidden: false
                };
            });

            this.currentColumns = allColumns;
            this.onSubmit();
        },
        onSubmit(event) {
            console.log('onSubmit')
            if (event) {
                event.preventDefault();
            }
            this.$emit('filterchange', event);
            this.$emit('closemenu');
        },
        onMenuItemClick() {
            const value = !this.columnsExpanded;
            this.columnsExpanded = value;
            this.filterExpanded = value ? false : this.filterExpanded;
        },
        onFilterExpandChange(value) {
            this.filterExpanded = value;
            this.columnsExpanded = value ? false : this.columnsExpanded;
        },
        expandChange() {
            this.$emit('expandchange');
        },
        closeMenu() {
            this.$emit('closemenu');
        },
        filterChange(newDescriptor, e) {
            // 确保传递的是 value 值而不是 displayText 
            let oringalData=newDescriptor;
             if (oringalData && oringalData.filters) {
                // 处理多条件过滤
                const processedDescriptor = {
                    ...oringalData,
                    filters: oringalData.filters.map(filterItem => { 
                        return {
                            ...filterItem,
                            filters:filterItem.filters.map(subFilter=>{
                               return{
                                ...subFilter,
                                value:this.getOriginalValueFromText(subFilter.value)
                               } 
                            }) 
                        };
                    })
                };
        //if(newDescriptor.filters.length>0){
          
        //}
        this.$emit('filterchange', processedDescriptor, e);
          this.$emit('setEboothFilter', newDescriptor); 
        } else {
         //if(newDescriptor.filters.length>0){ 
        //}
        this.$emit('filterchange', newDescriptor, e);
          this.$emit('setEboothFilter', newDescriptor); 
        } 
     }, 
     getOriginalValueFromText(displayText) {

         const currentLang = localStorage.getItem('currentLangId');  
         let itemOrigina =null;
         if(currentLang=='936')
         {
            itemOrigina=this.originalItems.find(a=>a.eBoothGradeNameSc==displayText);
         }else if(currentLang=='950'){
            itemOrigina=this.originalItems.find(a=>a.eBoothGradeNameTc==displayText);
         }else {
             itemOrigina=this.originalItems.find(a=>a.eBoothGradeNameEn==displayText);
         }
         let value='';
         if(itemOrigina)
         {
            value=itemOrigina.value;
         }
 
        return value ? value : '';
    },
       sortChange(newDescriptor, e) {
            this.$emit('sortchange', newDescriptor, e);
       }
    }
}
</script>